import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type State = {
  lsDeviceToken: string
}

function setLsDeviceToken(newToken: string) {
  useLsDeviceTokenStore.setState({ lsDeviceToken: newToken })
}

const useLsDeviceTokenStore = create<State>()(
  persist(
    () => ({
      lsDeviceToken: '',
    }),
    {
      name: 'device-token',
      partialize: (state) => ({ lsDeviceToken: state.lsDeviceToken }),
    }
  )
)

const useLsDeviceToken = () =>
  useLsDeviceTokenStore((state) => state.lsDeviceToken)

export { useLsDeviceToken, setLsDeviceToken }
